var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"codeContainer",staticClass:"monaco-editor"})
}
var staticRenderFns = []

export { render, staticRenderFns }